(ns quuppa.qsm.signin.view
  (:require [re-frame.core :as rf]
            ; [reitit.frontend.easy :as rfe]
            [quuppa.ui.dropdown :as dropdown]
            [quuppa.ui.icons :refer [icon]]
            quuppa.qsm.signin.subs
            quuppa.qsm.signin.events
            [quuppa.qsm.features :as features]))

(defn strip-status-query-param
  "Given query parameters string, constructs URLSearchParams and drops 'status' parameter if it exists.
  Returns query string without 'status', or nil if no parameters left after 'status' removal."
  [search-str]
  (let [url-params (js/URLSearchParams. search-str)]
    (cond-> url-params
      ;; ?status=xyz is redirect from backend when some error, strip it away when proceeding (to new login for example)
      (.has url-params "status") (doto (.delete "status"))
      true (-> str not-empty))))

(defn current-location-for-from
  "Builds URI encoded string with the current path, query string and fragment.
  'status' query parameter from backend is dropped if present."
  []
  ;; # and other url characters need to be encoded
  (let [current          (str (.-pathname js/location)
                              (when-let [query-string (not-empty (.-search js/location))]
                                (some->> (strip-status-query-param query-string)
                                         (str "?")))
                              (.-hash js/location))
        rootish-location #{"/" "/#" "/#/"}]
    (when-not (contains? rootish-location current)
      (js/encodeURIComponent current))))

(defn browser-uri-query-param [param]
  (let [search-string (.-search (.-location js/window))
        search-obj (js/URLSearchParams. search-string)]
    (.get search-obj param)))

(defn unauthorized-login-view [status]
  [:div.alert.alert-warning.text-center
   [:h5 "Login Error"]
   [:p.mb-0 (case status
              "unauthorized" "You are not authorized to access this QSM."
              "unauthenticated" "Invalid login credentials."
              "Either invalid login credentials or un-authorized access to the QSM.")]])

(defn signin-page []
  (let [status (browser-uri-query-param "status")]
    [:div.d-flex.flex-column.flex-grow-1
     [:nav.navbar.navbar-expand-lg
      [:a.navbar-brand.px-3.d-flex.py-3
       {:href "#/"}
       [icon :quuppa-horizontal.text-black
        {:viewBox "0 0 88 18"
         :style {:height "1em"}}]]]
     (when status
       [unauthorized-login-view status])
     [:div.d-flex.flex-column.align-items-center.flex-grow-1.justify-content-center.py-2
      [:h1.display-4.mb-5.text-center
       "Welcome to Quuppa Site Manager"]
      [:div.d-flex.flex-column.align-items-center
       [:h6.text-muted.mb-3.text-center "Sign in with your Quuppa account"]
       [:a.mx-2.btn.btn-primary.d-flex.align-items-center.justify-content-center.w-100.fw-medium
        {:data-test-id "quuppa-login"
         :href (str "/oauth/quuppa?from=" (current-location-for-from))}
        [icon :person-circle.mr-4
         {:style {:font-size "18px"}}]
        "Quuppa"]
       (when (features/enabled? :google-login)
         [:<>
          [:div.text-muted.my-3.fs-6.d-flex.flex-row.align-items-center.w-75
           [:div.border-bottom.border-gray-300.flex-grow-1]
           [:span.mx-2.fw-medium.text-gray-500 "or"]
           [:div.border-bottom.border-gray-300.flex-grow-1]]
          [:a.mx-2.btn.btn-outline-light.border-gray-200.text-gray-700.d-flex.align-items-center.justify-content-center.w-100.fw-medium
           {:data-test-id "google-login"
            :href         (str "/oauth/google" (when-let [location (current-location-for-from)] (str "?from=" location)))}
           [icon :google.mr-4
            {:style {:font-size "18px"}}]
           "Sign in with Google"]
          [:p.text-muted.mt-2.text-center [:small "Only @quuppa.com addresses are allowed"]]])]]]))

(defn navbar-user-controls []
  (let [{user-name :name roles :roles} @(rf/subscribe [:user/user])]
    [dropdown/dropdown
     [dropdown/toggle
      {:variant "default"
       :class "nav-link px-2"
       :bs-prefix "dropdown-toggle-no-caret"}
      [:div
       [:span.text-black.d-none.d-md-inline.mr-2
         user-name
        [:i (str " / QSM " (first roles))]]
       [icon :person-circle.icon-md.text-primary]]]
     [dropdown/menu
      ;; TODO: Go to profile item
      [dropdown/item
       {:on-click #(rf/dispatch [:user/signout])}
       "Sign out"]]]))

(defn profile-page []
  [:div "TODO"])
